import { createSlice } from "@reduxjs/toolkit";

// reducer
const initialState = { 

 };

const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    hydrate: (state, action) => {
      return action.payload; // replace entire state
    },
  },
});

export const { hydrate } = slice.actions;